import { IS_DEV_ENV } from "../../shared/constants/environment";
import { postHogService } from "./postHogService";

class IntercomService {
  open = (customURL?: any): void => {
    if (this.openCustomSupportPortal({ customURL })) return;

    if (window.Intercom) {
      window.document.documentElement.setAttribute(
        "data-show-intercom",
        "true"
      );
      window.Intercom("show");
      window.Intercom("onHide", () => {
        window.document.documentElement.removeAttribute("data-show-intercom");
      });
    } else if (IS_DEV_ENV) {
      console.log("Intercom is opened");
    } else {
      console.error("Intercom is not defined");
    }
  };

  openWithMessage = (message: string, customURL?: string): void => {
    if (this.openCustomSupportPortal({ customURL, message })) return;

    this.open();

    if (window.Intercom) {
      window.Intercom("showNewMessage", message);
    } else if (IS_DEV_ENV) {
      console.log("Intercom message sent:", message);
    }
  };

  openErrorSupport = (): void => {
    const replayUrl = postHogService.getSessionReplayUrl();

    replayUrl
      ? this.openWithMessage(
          `Hi there! I just got an error #${replayUrl}. Could you help me with it?\n\n`
        )
      : this.open();
  };

  shutdown = (): void => {
    window.Intercom?.("shutdown");
  };

  private openCustomSupportPortal = ({
    message,
    customURL
  }: {
    message?: string;
    customURL?: any;
  }): boolean => {
    const customSupportURL =
      typeof customURL === "string"
        ? customURL
        : window.organizationAccountConfig?.support?.portal.generalUrl;

    if (!customSupportURL) {
      return false;
    }

    const width = 400;
    const height = 600;

    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    const features = [
      `width=${width}`,
      `height=${height}`,
      `left=${left}`,
      `top=${top}`,
      "resizable=yes",
      "scrollbars=yes",
      "status=no",
      "location=no",
      "toolbar=no",
      "menubar=no"
    ].join(",");

    window.open(
      message
        ? `${customSupportURL}?message=${encodeURIComponent(message)}`
        : customSupportURL,
      "targetWindow",
      features
    );

    console.info("Custom support portal is opened!");

    return true;
  };
}

export const intercomService = new IntercomService();
